import apiClient from 'api';

const authServerBaseUrl = window.env.REACT_APP_SERVER_API_PATH;

export const fetchActivityLogs = async () => {
  // TODO: pagination
  return await apiClient.get(authServerBaseUrl, `/logs`);
};
